import React, { Component } from "react";
import Logo from "../assets/images/avwoodlogo.png";

export default class ProductAuthenticationGeneric extends Component {
  render() {
    const ResponseCode = "400";
    const isGenuine = ResponseCode === "200";
    const ResponseMessage = "This product is from AVI group";
    return (
      <div className="newpa-container">
        {isGenuine && (
          <div className="newpa-top-logo">
            <img src={Logo} alt="product" className="newpa-top-logo-img" />
          </div>
        )}

        <div className="newpa-card">
          {isGenuine ? (
            <h2 className="newpa-message genuine">{ResponseMessage}</h2>
          ) : (
            <h2 className="newpa-message fake">{ResponseMessage}</h2>
          )}
        </div>
      </div>
    );
  }
}
